import { useEffect } from 'react'

import { handleEmbedPrefillMessage } from 'services/embed_prefill_handoff'

/**
 * Registers window message listener for embed prefill. Messages are only applied when
 * embed_domain on the URL matches the postMessage origin (see embed_prefill_handoff).
 */
export const EmbedPrefillMessageListener = () => {
  useEffect(() => {
    window.addEventListener('message', handleEmbedPrefillMessage)
    return () => window.removeEventListener('message', handleEmbedPrefillMessage)
  }, [])

  return null
}
